module.exports = new __parcel__URL__("DarkEmptyState.b237e8cb.png").toString();